document.addEventListener("DOMContentLoaded", () => {
  const validators = {
    name: (input) =>
      /^[^\d!@#$%^&*()_+=\[\]{};:'",.<>/?\\|`~0-9]+$/u.test(input.value.trim()),

    email: (input) =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim()),

    phone: (input) =>
      /^[+\d\s]+$/.test(input.value.trim()),

    integer: (input) =>
      /^-?\d+$/.test(input.value.trim()),

    required: (input) => {
      if (input.type === "checkbox") return input.checked;
      return input.value.trim() !== "";
    },

    match: (input) => {
      const targetId = input.dataset.match;
      if (!targetId) return true; // no target specified, skip
      const target = document.getElementById(targetId);
      if (!target) return true; // target not found, skip
      return input.value === target.value;
    }
  };

  function showError(input, message) {
    input.classList.add("has-error");
    const wrapper = input.closest(".input-block") || input.parentNode;
    let errorDiv = wrapper.querySelector(".error-tip");
    if (!errorDiv) {
      errorDiv = document.createElement("div");
      errorDiv.className = "error-tip";
      wrapper.appendChild(errorDiv);
    }
    errorDiv.textContent = message;
  }

  function removeError(input) {
    input.classList.remove("has-error");
    const wrapper = input.closest(".input-block") || input.parentNode;
    const errorDiv = wrapper.querySelector(".error-tip");
    if (errorDiv) errorDiv.remove();
  }

  function validateField(input) {
    if (!input.dataset.validate) return true;

    const methods = input.dataset.validate.split(",").map(m => m.trim());
    for (let method of methods) {
      if (!validators[method]) continue;
      const valid = validators[method](input);
      if (!valid) {
        showError(input, errMsg[method] || "Invalid value.");
        return false;
      }
    }
    removeError(input);
    return true;
  }

  const fields = document.querySelectorAll(".js-validate");

  // Trigger validation on blur
  fields.forEach(input => {
    input.addEventListener("blur", () => validateField(input));
  });

  // Trigger validation on form submit
  const forms = document.querySelectorAll(".js-form");
    forms.forEach(form => {
        form.addEventListener("submit", (e) => {
            let valid = true;
            const fields = form.querySelectorAll(".js-validate"); // only check fields in this form

            fields.forEach(input => {
                if (!validateField(input)) valid = false;
            });


            if (!valid) {
            e.preventDefault();   // stop submission
            e.stopImmediatePropagation();
            return false;
            }
        });
    });
});
